import * as React from "react";
import ReactTooltip from 'react-tooltip';

export const Tooltip: React.FC = () => <ReactTooltip  place="right" delayShow={500}/>;

export const IconTooltip: React.FC = () => <ReactTooltip  id="icon" place="top" delayShow={100}/>;
